import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Card } from '../components/ui/Card';

export const RegisterPage: React.FC = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const { register, isLoading, error, clearError } = useAuthStore();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    clearError();

    if (password !== confirmPassword) {
      return;
    }

    try {
      await register(name, email, password);
      navigate('/assessment');
    } catch (error) {
      navigate('/register', { state: { error: 'Falha ao criar conta. Verifique seus dados.' } });
    }
  };

  const passwordsMatch = password === confirmPassword;
  const canSubmit = name && email && password && confirmPassword && passwordsMatch;

  return (
    <div className="max-w-md mx-auto mt-10 p-6">
      <Card>
        <div className="space-y-6">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-slate-900">Criar conta gratuita</h1>
            <p className="text-slate-600">
              Comece sua jornada de desenvolvimento comunicativo
            </p>
          </div>

          {error && (
            <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-sm text-red-600">{error}</p>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              label="Nome completo"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Seu nome completo"
              required
            />

            <Input
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu@email.com"
              required
            />

            <Input
              label="Senha"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              helper="Mínimo 6 caracteres"
              required
            />

            <Input
              label="Confirmar senha"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="••••••••"
              error={confirmPassword && !passwordsMatch ? 'Senhas não coincidem' : undefined}
              required
            />

            <Button
              type="submit"
              className="w-full bg-primary-600 hover:bg-primary-700 text-white font-semibold py-3 shadow-md hover:shadow-lg transition-all duration-200"
              loading={isLoading}
              disabled={!canSubmit}
            >
              Criar conta gratuita
            </Button>
          </form>

          <div className="text-center space-y-2">
            <p className="text-sm text-slate-600">
              Já tem uma conta?{' '}
              <Link to="/login" className="text-primary-600 hover:text-primary-700 font-medium">
                Faça login
              </Link>
            </p>
            <Link to="/" className="text-sm text-slate-500 hover:text-slate-700">
              ← Voltar ao início
            </Link>
          </div>

          <div className="text-xs text-slate-500 text-center">
            Ao criar uma conta, você concorda com nossos{' '}
            <a href="#" className="text-primary-600 hover:text-primary-700">
              Termos de Uso
            </a>{' '}
            e{' '}
            <a href="#" className="text-primary-600 hover:text-primary-700">
              Política de Privacidade
            </a>
          </div>
        </div>
      </Card>
    </div>
  );
};